import React, { useEffect } from 'react';
import Board from '@asseinfo/react-kanban'
import '@asseinfo/react-kanban/dist/styles.css'
import '../../kanban-overrides.css';
import Card from '../Kanban/Card';
import ColumnHeader from '../Kanban/ColumnHeader';

export default function Act(props) {
    const ACT_BEAT_MAPPING = {
        1: {
            actNum: 1,
            actName: 'beg',
            actInfo: '',
            actBeats: [
                {
                    beatNum: 1,
                    beatName: 'Opening Image',
                    beatInfo: 'The opening snapshot that tells us how your story opens. The first thing the audience sees/knows',
                    percent: null,
                    begPercent: 0,
                    endPercent: 1
                },
                {
                    beatNum: 2,
                    beatName: 'Theme Stated',
                    beatInfo: 'Introduction to the driving force and central theme of the story',
                    percent: 5,
                    begPercent: null,
                    endPercent: null
                },
                {
                    beatNum: 3,
                    beatName: 'Set Up',
                    beatInfo: 'Introduce, explore, experience the MCs world',
                    percent: null,
                    begPercent: 1,
                    endPercent: 10
                },
                {
                    beatNum: 4,
                    beatName: 'Catalyst',
                    beatInfo: 'An event occurs that changes the course of the story. ',
                    percent: 10,
                    begPercent: null,
                    endPercent: null
                },
                {
                    beatNum: 5,
                    beatName: 'Debate',
                    beatInfo: 'The MC has to take a step. Pressure mounts. A reaction to the Catalyst.',
                    percent: null,
                    begPercent: 10,
                    endPercent: 20
                }
            ]
        },
        2: {
            actNum: 2,
            actName: 'mid',
            actInfo: '',
            actBeats: [
                {
                    beatNum: 6,
                    beatName: 'Break Into 2',
                    beatInfo: 'The MC takes the decision and initiates the story pace',
                    percent: 20,
                    begPercent: null,
                    endPercent: null
                },
                {
                    beatNum: 7,
                    beatName: 'B Story',
                    beatInfo: 'Introduce or emphasize subplots or the surrounding events. Explore other characters.',
                    percent: 22,
                    begPercent: null,
                    endPercent: null
                },
                {
                    beatNum: 8,
                    beatName: 'Fun & Games',
                    beatInfo: 'Promise of the Premise. Entertaining for the audience. The journey to show the audience before everything changes.',
                    percent: null,
                    begPercent: 20,
                    endPercent: 50
                },
                {
                    beatNum: 9,
                    beatName: 'Midpoint',
                    beatInfo: 'Things change and stakes rise.',
                    percent: 50,
                    begPercent: null,
                    endPercent: null
                },
                {
                    beatNum: 10,
                    beatName: 'Bad Guys Close In',
                    beatInfo: 'Villain overpowers the hero. Things begin to go downhill',
                    percent: null,
                    begPercent: 50,
                    endPercent: 75
                },
                {
                    beatNum: 11,
                    beatName: 'All is Lost',
                    beatInfo: 'Rock bottom. Lowest point. Defeat.',
                    percent: 75,
                    begPercent: null,
                    endPercent: null
                },
                {
                    beatNum: 12,
                    beatName: 'Dark Night of the Soul',
                    beatInfo: 'MC acknowledges/realises the loss. Setup for the sacrifice required to set things right.',
                    percent: null,
                    begPercent: 75,
                    endPercent: 80
                }
            ]
        },
        3: {
            actNum: 3,
            actName: 'end',
            actInfo: '',
            actBeats: [
                {
                    beatNum: 13,
                    beatName: 'Break Into 3',
                    beatInfo: 'New discovery or new hope. MC is convinced to move forward.',
                    percent: 80,
                    begPercent: null,
                    endPercent: null
                },
                {
                    beatNum: 14,
                    beatName: 'Finale',
                    beatInfo: 'Putting the new dicsovery/hope to use to retrieve support. Things go the MCs way',
                    percent: null,
                    begPercent: 80,
                    endPercent: 99
                },
                {
                    beatNum: 15,
                    beatName: 'Final Image',
                    beatInfo: 'The final snapshot. The last thing the audience sees. Usually a mirror or contrast to the opening image',
                    percent: null,
                    begPercent: 99,
                    endPercent: 100
                }
            ]
        },
    }

    let getBoardFormat = (actNum) => {
        let board = {
            columns: []
        }
        let actDetails = ACT_BEAT_MAPPING[actNum];
        actDetails.actBeats.forEach(beat => {
            let columnDetail = {
                id: beat.beatNum,
                title: beat.beatName,
                desc: beat.beatInfo,
                percent: beat.percent,
                begPercent: beat.begPercent,
                endPercent: beat.endPercent,
                cards: []
            }
            board.columns.push(columnDetail);
        });
        return board;
    }

    let updateMainData = (data) => {
        props.updateMainData(props.actNum, data);
    }

    useEffect(() => {
        let initalBoard = getBoardFormat(props.actNum);
        console.log('sending..', props.actNum, initalBoard)
        props.updateMainData(props.actNum, initalBoard)
    }, []);

    let actWrapperCss = {
        background: "transparent",
        width: "max-content"
    }

    if (props.printState == 'non-print') {
        actWrapperCss['maxHeight'] = "70vh"
    }

    return (
        <div className="act-wrapper position-relative mx-2 p-3 rounded" style={actWrapperCss}>
            <div className="act-sidebar position-sticky" style={{width: "70px", marginLeft: "10px", left: "10px"}}>
                <h3>ACT { props.actNum }</h3>
            </div>
            <div className="act-content">
                <Board
                    disableColumnDrag
                    allowRemoveLane
                    allowRemoveCard
                    onCardNew={updateMainData}
                    onLaneRemove={() => {}}
                    onCardRemove={updateMainData}
                    initialBoard={getBoardFormat(props.actNum)}
                    allowAddCard={{ on: "bottom" }}
                    onNewCardConfirm={draftCard => ({
                      id: new Date().getTime(),
                      ...draftCard
                    })}

                    renderCard={(card, { removeCard, dragging }) => {
                        return (
                            <Card 
                                title={card.title} 
                                description={card.description}
                                removeCard={removeCard}
                                dragging={dragging} />
                        )
                    }}
                    renderColumnHeader={(column, { removeColumn, renameColumn, addCard }) => {
                        return (
                            <ColumnHeader
                                title={column.title}
                                description={column.desc}
                                removeColumn={removeColumn}
                                renameColumn={renameColumn}
                                addCard={addCard}
                            />
                        )
                    }}
                />
            </div>
        </div>
    )
}
